import React, {useCallback, useEffect, useRef} from 'react';
import * as ReactDOM from 'react-dom';
import CloseIcon from '../Icons/CloseIcon';
import SvgIcon from "../../Components/Icons/SvgIcon";

interface IProps {
    hide(): void,
    header: string | JSX.Element,
    content: JSX.Element
}

const BaseModal: React.FC<IProps> = ({ hide, header, content }): JSX.Element | null => {
    const modalRef = useRef(null);

    const handleKeyDown = useCallback((event): void => {
        if (event.keyCode === 27) {
            hide();
        }
    }, [hide]);

    useEffect((): () => void => {
        if (modalRef.current) {
            // @ts-ignore
            modalRef.current.focus();
        }

        window.addEventListener('keydown', handleKeyDown);

        // Cleanup, remove listener when component is unmounted
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        }
    }, [handleKeyDown]);

    return ReactDOM.createPortal(
        <React.Fragment>
            <div className="fixed top-0 left-0 z-40 w-screen h-screen bg-black bg-opacity-50" />
            <div
                className="fixed top-0 left-0 z-50 w-full h-full overflow-x-hidden overflow-y-auto outline-none flex justify-center items-center"
                aria-modal
                aria-hidden
                tabIndex={-1}
                role='dialog'
                ref={modalRef}
            >
                <div className="bg-white relative rounded-xl w-max-300 w-96">
                    <div className="flex justify-between items-center text-xl text-black-400 font-bold pt-4 px-7">
                        <span>{header}</span>
                        <span onClick={hide}>
                            <SvgIcon width='32px' height='32px' viewBox='0 0 32 32' className="cursor-pointer fill-gray-500">
                                <CloseIcon />
                            </SvgIcon>
                        </span>
                    </div>
                    <div className="pb-4 px-7 text-black-300">{content}</div>
                </div>
            </div>
        </React.Fragment>,
        document.body
    );
};

export default BaseModal;
